var rangetouch = {exports: {}};

export { rangetouch as __module };
